import { z } from 'zod';

/** Apprendimento (Fase 5): consensi, proposte, osservazione delle varianti, autonomia. */

export const CONSENT_SECTIONS = ['operazioni', 'persone_presenze', 'archivio'] as const;
export type ConsentSection = (typeof CONSENT_SECTIONS)[number];

export interface ConsentEntry {
  section: ConsentSection;
  purpose: 'ottimizzazione' | 'telemetria';
  granted: boolean;
  granted_at: string | null;
  label: string;
  description: string;
  warning: string | null;
}

export const SetConsentSchema = z.object({
  section: z.enum(CONSENT_SECTIONS),
  purpose: z.enum(['ottimizzazione', 'telemetria']),
  granted: z.boolean(),
});

export type ProposalStatus = 'aperta' | 'accettata' | 'rifiutata' | 'rimandata' | 'superata';

export interface ProposalDto {
  id: string;
  process_id: string | null;
  process_name: string | null;
  kind: 'variante_processo' | 'autonomia' | 'integrazione' | 'controllo' | 'correzione_controllo';
  detector: string;
  title: string;
  rationale: string;
  benefit: string | null;
  evidence: Record<string, unknown>;
  has_variant: boolean;
  /** Controllo proposto (ADR 0018) o correzione di un controllo esistente. */
  control: { controllo?: unknown; control_id?: string; azione?: 'correggi' | 'spegni'; verifica?: unknown } | null;
  /** Variante in forma leggibile (contratto normalizzato + procedura derivata). */
  variant: { contract: unknown; procedure: unknown } | null;
  status: ProposalStatus;
  decision_reason: string | null;
  answered_at: string | null;
  remind_after: string | null;
  created_at: string;
}

export const AnswerProposalSchema = z.object({
  decision: z.enum(['accetta', 'rifiuta', 'piu_avanti']),
  reason: z.string().trim().max(1000).optional(),
});
export type AnswerProposalInput = z.infer<typeof AnswerProposalSchema>;

export interface AnalysisResult {
  findings: number;
  created: number;
  suppressed: number;
}

export interface VersionMetrics {
  procedure_id: string;
  version: number;
  status: string;
  runs: number;
  runs_closed: number;
  avg_duration_minutes: number | null;
  rework_rate: number | null;
  exceptions_per_run: number | null;
  reassignments_per_run: number | null;
}

export interface ObservationDto {
  active: VersionMetrics | null;
  observation: VersionMetrics | null;
  since: string | null;
  /** Lettura sintetica del confronto, con il numero minimo di esecuzioni per giudicare. */
  verdict: 'insufficiente' | 'migliore' | 'peggiore' | 'equivalente' | null;
  min_runs: number;
}
